<template>
  <svg v-show="calculatedIcon" :width="size" :height="size" viewBox="0 0 24 24" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" :d="calculatedIcon" :fill="fillColor" />
  </svg>
</template>

<script setup>
import { computed } from 'vue';
import { color, dimensions } from './helper';

const props = defineProps({
  icon: {
    type: Object,
    default: () => ({
      d: '',
      theme: {
        light: '',
        dark: '',
      },
    }),
  },
  theme: {
    type: String,
    default: 'dark',
    validator: (val) => ['dark', 'light'].includes(val),
  },
  size: {
    type: String,
    default: 'm',
    validator: (val) => ['s', 'm', 'l', 'xl'].includes(val),
  },
});

const fillColor = computed(() => color(props.theme, props.icon?.theme));
const size = computed(() => dimensions(props.size));
const calculatedIcon = computed(() => props.icon.d);
</script>
